import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";

type SortableHeadAlign = "left" | "right" | "center";

interface SortableHeadProps {
  label: string;
  column: string;
  currentSort: string;
  isSortDesc: boolean;
  onSort: (column: string) => void;
  align?: SortableHeadAlign;
}

export const SortableHead = ({
  label,
  column,
  currentSort,
  isSortDesc,
  onSort,
  align = "left",
}: SortableHeadProps) => {
  const isActive = currentSort === column;

  return (
    <TableHead
      className={`cursor-pointer select-none hover:bg-muted/50 transition-colors ${align === "right" ? "text-right" : align === "center" ? "text-center" : ""}`}
      onClick={() => onSort(column)}
    >
      <div
        className={`flex items-center gap-1 ${align === "right" ? "justify-end" : align === "center" ? "justify-center" : ""}`}
      >
        {label}
        {isActive ? (
          isSortDesc ? (
            <ArrowDown className="w-3 h-3 text-primary" />
          ) : (
            <ArrowUp className="w-3 h-3 text-primary" />
          )
        ) : (
          <ArrowUpDown className="w-3 h-3 text-muted-foreground opacity-50" />
        )}
      </div>
    </TableHead>
  );
};
